import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import { useCreatePromotionCertificateMutation } from "../Redux/actions/certificate.action"
import { updateFields, resetForm } from "../Redux/actions/formValue.action"
import { useSelector, useDispatch } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"
import _ from "lodash"

const PromotionCertificateForm = () => {
    const dispatch = useDispatch()
    const [generatePromotionCer, generatePromotionCerState] = useCreatePromotionCertificateMutation()

    const formValue = useSelector(state => state.form)
    const student_name = _.get(formValue, "state.student_name", "")
    const institution_name = _.get(formValue, "state.institution_name", "")
    const from_class = _.get(formValue, "state.from_class", "")
    const to_class = _.get(formValue,"state.to_class","")
    const academic_year = _.get(formValue,"state.academic_year","")


    React.useEffect(() => {
        if (generatePromotionCerState.isSuccess) {
            const blob = generatePromotionCerState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "Promotion_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generatePromotionCerState.reset()
            dispatch(resetForm())
        } else if (generatePromotionCerState.isError) {
            toaster.push(<Message type="error" >Error while create the School Leaving certificate,Please try again later!</Message>, { placement: "topCenter" })
            generatePromotionCerState.reset()
        }
    }, [generatePromotionCerState.status])
    const handleSubmit = () => {
        if (
            !student_name || !from_class || !institution_name || !to_class || !academic_year
        ) {
            toaster.push(<Message type="info">Please fill all fields value!</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            student_name:student_name,
            institution:institution_name,
            to_class:to_class,
            from_class:from_class,
            academic_year:academic_year
        }
        generatePromotionCer(data)
    }

    return (
        <Box sx={{ maxWidth: 720, mx: "auto", mt: 5 }}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        Promotion's Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Enter student and school details carefully
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            placeholder="eg.Bhuban Padun"
                            value={student_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ student_name: val }))
                            }}
                        />
                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            placeholder="eg. ABC Public School"
                            fullWidth
                            value={institution_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />
                        <TextField
                            label="Present Class Name"
                            name="from_class"
                            placeholder="eg. Class-1"
                            rows={2}
                            fullWidth
                            value={from_class}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ from_class: val }))
                            }}
                        />
                        <TextField
                            label="Promoted Class Name"
                            name="to_class"
                            placeholder="eg. Class-2"
                            rows={2}
                            fullWidth
                            value={to_class}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ to_class: val }))
                            }}
                        />
                        <TextField
                            label="Academic Year"
                            name="academic_year"
                            placeholder="eg. 2026 - 2027"
                            rows={2}
                            fullWidth
                            value={academic_year}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ academic_year: val }))
                            }}
                        />
                        
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generatePromotionCerState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    );
};

export default PromotionCertificateForm
